import { SwanLogo } from "@/components/Brand";

export default function Loader({ label = "Loading…" }) {
  return (
    <div className="swan-bg min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="animate-pulse">
        <SwanLogo size={56} />
      </div>
      <p className="text-slate-400 text-sm">{label}</p>
    </div>
  );
}
